import React, { useState, useRef } from "react";
import { Box, Center, Icon, Text } from "@chakra-ui/react";
import { MdCloudUpload } from "react-icons/md";

export default function OnePDFDropzone(props) {
  const { childToParent } = props;

  const [file, setFile] = useState(null);
  const inputRef = useRef(null);

  const handleFileChange = (newFile) => {
    if (!newFile) return;
    
    // Validate file type
    if (newFile.type !== "application/pdf") {
      alert(`Invalid file type: ${newFile.type}. Please select a PDF file.`);
      return;
    }
    
    // Validate file size (100MB limit)
    const maxSize = 100 * 1024 * 1024; // 100MB
    if (newFile.size > maxSize) {
      alert(`File too large: ${(newFile.size / (1024 * 1024)).toFixed(1)}MB. Maximum size is 100MB.`);
      return;
    }
    
    console.log("File selected:", {
      name: newFile.name,
      type: newFile.type,
      size: `${(newFile.size / (1024 * 1024)).toFixed(2)}MB`
    });
    
    setFile(newFile);
    // Pass the file object to the parent component
    childToParent(newFile);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const newFile = e.dataTransfer.files[0];
    handleFileChange(newFile);
  };

  const handleContainerClick = () => {
    // Trigger the file input click when the container is clicked
    inputRef.current.click();
  };

  return (
    <Box className="pdf-container" onClick={handleContainerClick}>
      <Box className="pdf">
        <Box
          border="dashed"
          borderWidth={2}
          borderColor="gray.300"
          borderRadius="md"
          p={4}
          textAlign="center"
          cursor="pointer"
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleDrop}
          minH="100px"
        >
          {file ? (
            <Text>{file.name}</Text>
          ) : (
            <Center flexDirection="column">
              <Icon as={MdCloudUpload} boxSize={8} mb={2} color="gray.300" />
              <Text fontSize="sm" fontWeight="semibold" color="gray.700">
                Drop or add pdf file here
              </Text>
            </Center>
          )}
        </Box>
        <input
          ref={inputRef}
          type="file"
          accept="application/pdf"
          onChange={(e) => handleFileChange(e.target.files[0])}
          style={{ display: "none" }} // Hide the input
        />
      </Box>
    </Box>
  );
}
